<template>
	<div class="layout-profile">
		<div>
			<img :src="imagenUsuario" height="100"/>
		</div>
		<button class="p-link layout-profile-link" @click="onClick">
			<span class="username"> {{ nombreUsuario }}</span>
			<i class="pi pi-fw pi-cog"></i>
		</button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <li><button class="p-link"><i class="pi pi-fw pi-user"></i><span>Cuenta</span></button></li>
                <li><button class="p-link"><i class="pi pi-fw pi-inbox"></i><span>Notificaciones</span><span class="menuitem-badge">2</span></button></li>
                <li><button class="p-link" @click="logOut"><i class="pi pi-fw pi-power-off"></i><span>Logout</span></button></li>
            </ul>
        </transition>
	</div>
</template>

<script>
	import UsuarioService from "./service/seguridad/UsuarioService";
	import Swal from 'sweetalert2';
	export default {
		data() {
			return {
				expanded: false,
				imagenUsuario: null,
				nombreUsuario: null
			}
		},
		usuarioService: null,
		created() {
			this.usuarioService = new UsuarioService();
		},
		mounted() {
			this.cargarImagen();
			this.cargarNombreUsuario();
		},
		methods: {
			onClick(event){
				this.expanded = !this.expanded;
				event.preventDefault();
			},

			cargarNombreUsuario(){
				let user = JSON.parse(localStorage.getItem('user'));
				var nombre = user.nombres.split(" ");
				this.nombreUsuario = nombre[0] + " " + user.apellidos;
			},
			
			async cargarImagen(){
				let user = JSON.parse(localStorage.getItem('user'));
				await this.usuarioService.obtenerImagenUsuario(user.codUsuario).then(files => {
					if(files.data != ""){
						this.imagenUsuario = "data:image/png;base64,"+files.data;
					}else{
						this.imagenUsuario = "resources/images/user_default2.png";
					}
				}).catch(() => {
					this.currentFile = undefined;
					this.imagenUsuario = "resources/images/user_default2.png";
				});
			},

			logOut() {
				Swal.fire({
					title: 'Cerrar Sesión',
					text: "Esta seguro de Cerrar Sesión?",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Si',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					if (result.isConfirmed) {
						localStorage.removeItem('user');
						this.$router.push('/');
					}
				})
			},
		}
	}
</script>

<style scoped>

</style>